import React, {useEffect, useState} from "react";
import {
    Container,
    Dropdown,
    Button,
    Form,
    TextArea,
    Header, List, Step
} from "semantic-ui-react";
import {RootState} from "../model";
import {connect} from "react-redux";
import Template from "./Template";
import {useActions} from "../redux/actions";
import * as practiceActions from "../redux/actions/practice";
import * as openDentalActions from "../redux/actions/openDental";

function UpdateBulkUser() {
    const initialState: any = {
        practiceOpts: [],
        step : 1
    };
    const initialForm: any = {
        userNums: '',
        practice: null
    }
    const [state, setState] = useState(initialState);
    const [form, setFormData] = useState(initialForm);
    const [responseText, setResponseText] = useState<any>("");
    const [userData, setUserData] = useState<any>([]);

    const practiceAction = useActions(practiceActions);
    const openDentalAction = useActions(openDentalActions);

    useEffect(() => {
        setTimeout(() => {
            const practiceOpts: any = [];
            practiceAction.getAllPractices().then((practices: any) => {
                practices && practices.forEach((item: any) => {
                    const practice = item.practice;
                    practiceOpts.push({
                        key: practice.id,
                        value: practice.practiceDBName,
                        text: practice.practice
                    })
                })
            })
            setState({
                ...state,
                practiceOpts: practiceOpts
            })
        }, 500);
    }, []);

    const isValidCommaSeparatedNumbers = (value: string) => {
        return /^(\d+\s*,\s*)*\d+$/.test(value.trim());
    };

    const submitHandler = () => {
        if (!form || !form.userNums || !form.practice) {
            alert("Please fill all required fields.");
            return;
        }

        if (!isValidCommaSeparatedNumbers(form.userNums)) {
            alert("Please enter valid user numbers in comma separated format.");
            return;
        }
        if(state.step === 2){
            openDentalAction.updateBulkUser(form)
                .then((res: any) => {
                    setResponseText(res);
                    setState({...state, step: 3});
                    setFormData(initialForm);
                    setUserData([]);
                }).catch((err: any) => {
                    setResponseText(err);
                });
            return;
        }
        openDentalAction.getUsersByUserNums(form)
            .then((res: any) => {
                setUserData(res)
                setState({...state, step: 2})
            }).catch((err: any) => {
            setUserData([])
        })
    }
    const cancelHandler = () => {
        setFormData(initialForm);
        setResponseText("");
        setUserData([]);
    }
    return (
        <Template activeLink="update-bulk-user">
            <Container>
                <Header as="h2">
                    <Header.Content>Update Bulk User</Header.Content>
                </Header>

                <Step.Group ordered={true}>
                    <Step active={state.step ===1} completed={state.step > 1}>
                        <Step.Content>
                            <Step.Title>Fill Details</Step.Title>
                            <Step.Description>Please Fill in the following information</Step.Description>
                        </Step.Content>
                    </Step>

                    <Step active={state.step ===2} completed={state.step > 2}>
                        <Step.Content>
                            <Step.Title>Confirmation</Step.Title>
                            <Step.Description>Please confirm the list of Doctors</Step.Description>
                        </Step.Content>
                    </Step>

                    <Step active={state.step ===3} completed={state.step ===3}>
                        <Step.Content>
                            <Step.Title>Success</Step.Title>
                        </Step.Content>
                    </Step>
                </Step.Group>

                <Form className="mb20">
                    <Form.Field>
                        <label>Practices <span className={'red'}>*</span> </label>
                        <Dropdown
                            fluid={true}
                            selection={true}
                            options={state.practiceOpts}
                            onChange={(_, data) => {
                                setFormData({...form, practice: data.value as string})
                            }}
                        />
                    </Form.Field>
                    <Form.Field>
                        {userData.length > 0 ?
                            <>
                                <label>Users Found</label>
                                <List>
                                    {userData.map((user: any, index: number) => (
                                        <List.Item key={index}>
                                            <List.Content className={'mb10'}>
                                                <List.Header as='a'>{user.UserName}</List.Header>
                                                <List.Description>
                                                    Having User Num <b>{user.UserNum}</b> under
                                                    group <b>{user.groupName}</b>
                                                </List.Description>
                                            </List.Content>
                                        </List.Item>
                                    ))}

                                </List></>
                            : <>
                                <label>User Nums - (,) comma separated</label>
                                <TextArea
                                    placeholder='(,) comma separated user ids, e.g. 1,2,3'
                                    value={form.userNums}
                                    onChange={(e) => setFormData({...form, userNums: e.target.value})}
                                    rows={10}
                                />
                            </>}

                    </Form.Field>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>&nbsp;</label>
                            <Button
                                secondary={true}
                                fluid={true}
                                onClick={() => cancelHandler()}
                            >
                                Cancel
                            </Button>
                        </Form.Field>

                        <Form.Field>
                            <label>&nbsp;</label>
                            <Button
                                primary={true}
                                fluid={true}
                                onClick={() => submitHandler()}
                            >
                                Proceed
                            </Button>
                        </Form.Field>

                    </Form.Group>

                </Form>
                {responseText &&
                    <div className="ui card" style={{maxHeight: '350px', overflowY: 'auto'}}>
                        <div className="content">
                            <Header as="h4">Response</Header>
                            <pre>
                          {JSON.stringify(responseText, null, 2)}
                        </pre>
                        </div>
                    </div>
                }
            </Container>
        </Template>
    );
}

function mapStateToProps(state: RootState) {
    return {
        auth: state.auth,
        allPracticeList: state.practice.allPracticeList,
        loader: state.app.loader,
    };
}

export default connect(mapStateToProps)(UpdateBulkUser);
